import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M6.078 2.1h11.844c.261 0 .492 0 .684.016.203.016.415.054.62.158a1.6 1.6 0 0 1 .7.7c.104.205.142.417.158.62.016.192.016.423.016.684v16.06c0 .206 0 .4-.014.559-.015.16-.051.384-.196.583a1.1 1.1 0 0 1-.775.448 1.146 1.146 0 0 1-.603-.123c-.145-.067-.313-.164-.492-.267l-5.52-3.19c-.326-.19-.377-.21-.417-.22a.4.4 0 0 0-.166 0c-.04.01-.09.03-.417.22l-5.52 3.19c-.18.103-.347.2-.491.267a1.146 1.146 0 0 1-.604.123 1.1 1.1 0 0 1-.775-.448 1.147 1.147 0 0 1-.196-.583 6.579 6.579 0 0 1-.014-.56V4.279c0-.261 0-.492.016-.684.016-.203.054-.415.158-.62a1.6 1.6 0 0 1 .7-.7c.205-.104.417-.142.62-.158.192-.016.423-.016.684-.016Z"
      clip-rule="evenodd"
    />
  </svg>
`;
